<!-- 仓库 -->
<template>
    <div>
        <!-- 仓库信息 -->
         <!-- height: calc(100vh - 82px) -->
        <el-table :data="addressList" size="mini" style="margin-top: 0px;" height="20vh" :header-cell-style="{'text-align':'center'}">
            <el-table-column type="index" align="center"> </el-table-column>
            <el-table-column label="仓库编号" prop="code" align="center"></el-table-column>
            <el-table-column label="仓库名称" prop="name" width="150" align="center"> 
                <template slot-scope="scope">
                    <el-link type="primary" @click="getStore(scope.row)">{{scope.row.name}}</el-link>
                </template>
            </el-table-column>
            <el-table-column label="仓库面积" prop="area" align="center"></el-table-column>
            <el-table-column label="仓库属性" prop="property" align="center"></el-table-column>
            <el-table-column label="仓库地址" prop="address" width="300" align="center"></el-table-column>
            <el-table-column label="联系人" prop="contractMan" align="center"></el-table-column>
            <el-table-column label="电话" prop="phone" align="center"></el-table-column>
            <el-table-column label="邮箱" prop="email" width="200" align="center"></el-table-column>
            <el-table-column label="备注" prop="remark" width="200" align="center"></el-table-column>
            <el-table-column label="状态" width="80" align="center">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.isUse" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" 
                    :inactive-value="0" @change="changeIsuse(scope.row)"> </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-button v-if="permissionShow" size="mini" type="primary" plain @click="permission(scope.row)">人员权限</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-dialog title="仓库分区信息" :visible.sync="addressVisible" width="60%" :before-close="addressClose" v-dialogDrag
        :close-on-click-modal="false"> -->
        <!-- 库区信息 -->
        <div class="storeBox">
            <div>
                {{ addressDetail.name }}  库区列表
            </div>
            <el-button size="mini" type="primary" @click="addstore">新增</el-button>
        </div>
        <el-table :data="storeList" max-height="400px" size="mini" height="25vh">
            <el-table-column type="index" width="150"> </el-table-column>
            <el-table-column label="分区名称" prop="name" ></el-table-column>
            <el-table-column label="分区面积" prop="area" ></el-table-column>
            <el-table-column label="分区容量" prop="capacity" ></el-table-column>
            <!-- <el-table-column label="保税属性" prop="bondedProperty" ></el-table-column> -->
            <el-table-column label="分区属性" prop="manageProperty" ></el-table-column>
            <el-table-column label="分区备注" prop="remark" ></el-table-column>
            <el-table-column label="" prop="" >
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click="getLocation(scope.row)">查看库位</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- </el-dialog> -->
        <el-dialog :title="this.addressDetail.name + ' 新增仓库分区'" :visible.sync="storeVisible" width="30%" :before-close="storeClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-form ref="storeForm" :model="storeForm" label-width="120px" size="mini" :rules="rules">
                <el-form-item label="分区名称" prop="name">
                    <el-input v-model="storeForm.name"></el-input>
                </el-form-item>
                 <el-form-item label="分区面积" prop="area">
                    <el-input v-model="storeForm.area"  onkeyup="this.value=this.value.match(/\d*/)[0]"></el-input>
                </el-form-item>
                <el-form-item label="分区容量" prop="capacity">
                    <el-input v-model="storeForm.capacity"  onkeyup="this.value=this.value.match(/\d*/)[0]"></el-input>
                </el-form-item>
                <el-form-item label="分区属性" prop="manageProperty">
                    <el-select v-model="storeForm.manageProperty" placeholder="请选择管理属性" style="width: 100%;">
                        <el-option v-for="item in managePropertyList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分区备注" prop="remark">
                    <el-input v-model="storeForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddStore('storeForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- <el-dialog :title=" storeDetail.name + ' 库位信息'" :visible.sync="locationVisible" width="60%" :before-close="locationClose" v-dialogDrag
        :close-on-click-modal="false"> -->
        <!-- 库位信息 -->
        <div class="storeBox">
            <div>
                {{ storeDetail.name }}  库位列表
            </div>
            <el-button size="mini" type="primary" @click="addLocation">新增</el-button>
        </div>
        <el-table :data="locationList" size="mini" height="32vh">
            <el-table-column type="index" width="150"> </el-table-column>
            <el-table-column label="库位名称" prop="locationName" width="200"></el-table-column>
            <el-table-column label="库位面积" prop="area" ></el-table-column>
            <el-table-column label="库位容量" prop="capacity" ></el-table-column>
            <el-table-column label="库位类型" prop="locationType" ></el-table-column>
            <el-table-column label="库位备注" prop="remark" ></el-table-column>
        </el-table>
        <!-- </el-dialog> -->
        <el-dialog :title="this.storeDetail.name + ' 新增库位'" :visible.sync="addLocationVisible" width="30%" :before-close="addLocationClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-form ref="addLocationForm" :model="addLocationForm" label-width="80px" size="mini" :rules="locationRules">
                <el-form-item label="库位名称" prop="locationName">
                    <el-input v-model="addLocationForm.locationName"></el-input>
                </el-form-item>
                <el-form-item label="库位面积" prop="area">
                    <el-input v-model="addLocationForm.area" onkeyup="this.value=this.value.match(/\d*/)[0]"></el-input>
                </el-form-item>
                <el-form-item label="库位容量" prop="capacity">
                    <el-input v-model="addLocationForm.capacity" onkeyup="this.value=this.value.match(/\d*/)[0]"></el-input>
                </el-form-item>
                <el-form-item label="库位类型" prop="locationType">
                    <el-select v-model="addLocationForm.locationType" placeholder="请选择库位类型" style="width: 100%;">
                        <el-option v-for="item in locationTypeList" :key="item.value" :label="item.value" :value="item.value"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="库位备注" prop="remark">
                    <el-input v-model="addLocationForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="saveAddLocation('addLocationForm')">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 人员权限 -->
        <el-dialog :title="this.permissionForm.name + ' 人员权限'" :visible.sync="permissionVisible" width="60%" :before-close="permissionClose" v-dialogDrag
        :close-on-click-modal="false">
            <el-checkbox-group v-model="permissionForm.userList">
                <div style="display: flex; flex-wrap: wrap; max-width: 100%;">
                    <el-checkbox style="flex: 0 0 20%;margin: 5px;" v-for="item in userList" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                </div>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="savePermission()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 库位显示图 -->
         <!-- <wmsLocation></wmsLocation> -->
    </div>
</template>
<script>
import wmsLocation from '../../../components/wms/wmsLocation.vue'
export default {
    name: 'warehouse',
    components:{
        wmsLocation
    },
    //组件创建
    created() {
        this.getInfo()
        this.getLocationType()
        this.getbondedPropertyList()
        this.getmanagePropertyList()
        this.getUserList()
    },
    data() {
        return {
            addressList: [],
            // 查看仓库时地址信息
            addressDetail:{},
            // 仓库列表
            storeList: [],
            // 仓库弹出框
            addressVisible:false,
            // 新增仓库弹出框
            storeVisible:false,
            // 新增分区信息
            storeForm:{
                name:'',
                area:'',
                capacity:'',
                manageProperty:'',
                remark:'',
            },
            // 查看库位时仓库信息
            storeDetail:{},
            locationVisible:false, // 库位弹出框
            locationList:[],// 库位列表
            addLocationVisible:false,// 新增库位弹出框
            // 新增库位信息
            addLocationForm:{
                locationName:'',
                area:'',
                capacity:'',
                locationType:'',
                remark:'',
                storeId:'',
            },
            locationTypeList:[], // 库位类型列表
            bondedPropertyList:[], // 保税属性列表
            managePropertyList:[], // 管理属性列表
            rules:{
                name:[
                    { required: true, message: '请输入分区名称', trigger: 'blur' },
                ],
                area:[
                    { required: true, message: '请输入分区面积', trigger: 'blur' },
                ],
                capacity:[
                    { required: true, message: '请输入分区容量', trigger: 'blur' },
                ],
                manageProperty:[
                    { required: true, message: '请选择分区属性', trigger: 'change' },
                ],
            },
            locationRules:{
                locationName:[
                    { required: true, message: '请输入库位名称', trigger: 'blur' },
                ],
                area:[
                    { required: true, message: '请输入库位面积', trigger: 'blur' },
                ],
                capacity:[
                    { required: true, message: '请输入库位容量', trigger: 'blur' },
                ],
                locationType:[
                    { required: true, message: '请选择库位类型', trigger: 'change' },
                ],
            },
            userList:[], // 人员列表
            permissionShow:true,// 是否显示人员权限按钮
            permissionVisible:false,// 人员权限弹出框
            permissionForm:{
                name:'',
                id:'',
                userList:[],
            },// 人员权限Form
        }
    },
    methods: {
        getInfo(){
            this.$api.getInfo(  ).then(res =>{
               this.addressList = res
            })
        },
        changeIsuse(data){
            console.log(data)
        },
        getStore(data){
            this.$api.getStore( data.name ).then(res =>{
                this.storeList = res
                this.addressDetail = data
                this.addressVisible = true
            })  
            // 清空库位列表和父库区信息
            this.locationList = []
            this.storeDetail = {}
        },
        addressClose(){
            this.addressDetail = {}
            this.addressVisible = false
        },
        // 新增库区
        addstore(){
            // 判断是否选择库区
            if(!this.addressDetail.name){
                this.$message.error('请先选择仓库')
                return
            }
            this.storeVisible = true
            
        },
        saveAddStore(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        name: this.storeForm.name,
                        area: this.storeForm.area,
                        capacity: this.storeForm.capacity,
                        parentName: this.addressDetail.name,
                        manageProperty: this.storeForm.manageProperty,
                        remark: this.storeForm.remark,
                    }
                    console.log(params);
                    this.$api.insStore( params ).then(res =>{
                        this.storeClose()
                        this.$api.getStore( this.addressDetail.name ).then(res =>{
                            this.storeList = res
                        })
                    })  
                    
                } else {
                    return false;
                }
            });
        },
        storeClose(){
            this.storeVisible = false
            this.storeForm = {
                name: '',
                area: '',
            }
        },
        // 查看库位
        getLocation(data){
            this.storeDetail = data
            this.$api.getLocation( data.id ).then(res =>{
                this.locationVisible = true
                this.locationList = res
            })
        },
        // 库位关闭
        locationClose(){
            this.locationVisible = false
            this.locationList = []
        },
        // 新增库位
        addLocation(){
            // 判断是否选择库区
            if(!this.storeDetail.name){
                this.$message.error('请先选择库区')
                return
            }
            this.addLocationVisible = true 
        }, 
        // 获取库位类型
        getLocationType(){
            this.$api.getDicList( { value:'Wms库位类型'} ).then(res =>{
                this.locationTypeList = res
            })
        },
        // 获取管理属性
        getmanagePropertyList(){
            this.$api.getDicList( { value:'Wms管理属性'} ).then(res =>{
                this.managePropertyList = res
            })
        },
        // 获取保税属性
        getbondedPropertyList(){
            this.$api.getDicList( { value:'Wms保税属性'} ).then(res =>{
                this.bondedPropertyList = res
            })
        },
        // 保存新增库位
        saveAddLocation(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const params = {
                        locationName: this.addLocationForm.locationName,
                        area: this.addLocationForm.area,
                        capacity: this.addLocationForm.capacity,
                        locationType: this.addLocationForm.locationType,
                        remark: this.addLocationForm.remark,
                        storeId: this.storeDetail.id
                    }
                    this.$api.insLocation( params ).then(res =>{
                        this.$api.getLocation( params.storeId ).then(res =>{
                            this.locationList = res
                            this.$message({
                                message: '添加库位成功',
                                type: 'success'
                            });
                            this.addLocationClose()
                        })
                    })
                }
            })
        },
        // 关闭新增库位
        addLocationClose(){
            this.addLocationVisible = false
            this.$nextTick(()=>{
                this.$refs.addLocationForm.resetFields();
            })
            this.addLocationForm = {
                locationName:'',
                capacity:'',
                locationType:'',
                storeId:'',
                area:'',
                remark:'',
            }
        },
        // 获取所有用户
        getUserList(){
            this.$api.getUserList( ).then(res =>{
                this.permissionShow = true
                this.userList = res;
            }).catch(error => {
                this.permissionShow = false
            });
        },
        // 获取该仓库人员权限
        getWmsUser(id){
            this.$api.getWmsUser(id).then(res =>{
                this.permissionForm.userList = res
            })
        },
        // 打开设置仓库人员权限对话框
        permission(data){
            this.permissionForm.name = data.name
            this.permissionForm.id = data.id
            this.permissionVisible = true
            this.getWmsUser(this.permissionForm.id)
        },
        // 关闭人员权限对话框
        permissionClose(){
            this.permissionVisible = false
            this.permissionForm = {
                name: '',
                id: '',
                userList: []
            }
        },
        // 保存人员权限
        savePermission(){
            this.$api.assignWmsUser( this.permissionForm.id, this.permissionForm.userList ).then(res =>{
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
                this.permissionClose()
            })
        }
    }
}
</script>
<style style lang="less" scoped>
.storeBox{
    background-color: white;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
    margin-bottom: -15px;
    border-bottom: 1px solid #EBEEF5;
    padding: 5px 20px;
}
</style>